import Carousel from '../../components/carousel'
import Post from './post'
import { IMediumPost } from '../../types'

type Props = {
    posts: IMediumPost[]
}

const AboutPageNewsPosts = ({ posts = [] }: Props) => (
    <Carousel>
        {posts.map((post, i) => (
            <Post key={post.guid} index={i} post={post} />
        ))}
    </Carousel>
)

export default AboutPageNewsPosts
